import React, { useState } from 'react';
import './ThreeColumnWide.scss';
import {
    ThreeColumnWideColumn,
    ThreeColumnWideColumnProps,
} from './ThreeColumnWideColumn';
import {
    VideoPlayer,
    VideoPlayerProps,
    VideoPlayerTitleProps,
} from '../VideoPlayer/VideoPlayer';

export interface ThreeColumnWideProps {
    columns: [
        ThreeColumnWideColumnProps,
        ThreeColumnWideColumnProps,
        ThreeColumnWideColumnProps
    ];
    theme: `white` | `gray` | `dark`;
    align: `left` | `center`;
    size: `small` | `medium` | `large`;
    classNames?: string[];
}

export const ThreeColumnWide = (props: ThreeColumnWideProps) => {
    const [videoOpen, setVideoOpen] = useState<VideoPlayerProps>(null);
    const [videoTitle, setVideoTitle] = useState<VideoPlayerTitleProps>(null);

    if (
        !props.columns ||
        props.columns.length < 3 ||
        !props.columns.every(
            (col) => col.text || col.heading || col.image || col.video
        )
    ) {
        return (
            <p className="kite-container component-error">
                ERROR: Three column -- all three columns must be populated.
            </p>
        );
    }

    return (
        <section className={`themed-container c--three-column ${props.theme}`}>
            <div
                className={`kite-container ${props.align} ${props.size} ${
                    props.classNames && props.classNames?.join(` `)
                } `}
            >
                {props.columns.map((col, idx) => {
                    const nCol = {
                        ...col,
                        setVideoOpen: col.video ? setVideoOpen : undefined,
                        setVideoTitle: col.video ? setVideoTitle : undefined,
                    };
                    return (
                        <ThreeColumnWideColumn
                            key={idx}
                            {...nCol}
                            headingSize={props.size}
                        />
                    );
                })}
            </div>
            {videoOpen && (
                <div className="modal">
                    <VideoPlayer
                        videoUrl={videoOpen.videoUrl}
                        setVideoOpen={setVideoOpen}
                        videoTitle={videoTitle.videoTitle}
                        setVideoTitle={setVideoTitle}
                    />
                </div>
            )}
        </section>
    );
};
